<button
  class="m-b-24"
  mat-raised-button
  color="accent"
  (click)="toggle2Fa()">
  @if (user!.is2FAEnabled) {
    <mat-icon>do_not_disturb</mat-icon>
  }
  @if (!user!.is2FAEnabled) {
    <mat-icon>check</mat-icon>
  }
  {{ user!.is2FAEnabled ? 'Disable 2FA' : 'Enable 2FA' }}
</button>
